export default {
  'paymentConditions.domain.name': 'Nome',
  'paymentConditions.domain.percentage': 'Desc./Acres.(%)',
  'paymentConditions.domain.installments': 'Parcelas',
  'paymentConditions.domain.installments.add': 'Adicionar Parcela',
  'paymentConditions.domain.installments.intervalDays': 'Intervalo de Dias',
  'paymentConditions.domain.installments.percentage': 'Percentual',

  'paymentConditions.form.installments.rules.minimum': 'Pelo menos uma parcela',
  'paymentConditions.form.installments.rules.mustBe100':
    'A soma das porcentagens deve ser 100.',

  'paymentConditions.create': 'Criar Condição de Pagamento',
  'paymentConditions.create.notification.success': 'Sucesso',
  'paymentConditions.create.notification.successDescription':
    'Condição de Pagamento criada.',

  'paymentConditions.update': 'Editar Condição de Pagamento',
  'paymentConditions.update.notification.success': 'Sucesso',
  'paymentConditions.update.notification.successDescription':
    'Condição de Pagamento editada.',

  'paymentConditions.remove': 'Remover Condição de Pagamento',
  'paymentConditions.remove.alert':
    'Você realmente deseja remover a condição de pagamento:',
  'paymentConditions.remove.notification.success': 'Sucesso',
  'paymentConditions.remove.notification.successDescription':
    'Condição de Pagamento removida.',

  'paymentConditions.generateReport': 'Gerar Relatório',

  'paymentConditions.status.message.success':
    'Status das condições de pagamento alterado com sucesso!',
};
